import * as React from 'react';
import PropTypes from 'prop-types';
import ButtonBase from '@material-ui/core/ButtonBase';

import update from 'immutability-helper';

const TIME = 300;

const propTypes = {
  onClick: PropTypes.func,
  backgroundImage: PropTypes.string,
};

const defaultProps = {
  onClick: null,
  backgroundImage: null,
};

class ImageThumbnail extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isImageLoad: false,
    };
    this.loadImage = this.loadImage.bind(this);
  }

  componentDidMount() {
    this.time = setTimeout(this.loadImage, TIME);
  }

  componentWillUnmount() {
    clearTimeout(this.time);
    delete this.time;
  }

  loadImage() {
    this.setState(update(this.state, { isImageLoad: { $set: true } }));
  }

  render() {
    const { onClick, backgroundImage } = this.props;
    const { isImageLoad } = this.state;
    const style = {};

    if (isImageLoad && backgroundImage) {
      style.backgroundImage = `url(${backgroundImage})`;
    }
    return (
      <ButtonBase
        color="primary"
        classes={{ root: 'epg-item--video-play-btn' }}
        onClick={onClick}
        style={style}
      />
    );
  }
}

ImageThumbnail.propTypes = propTypes;
ImageThumbnail.defaultProps = defaultProps;

export default ImageThumbnail;
